import { TeamMemberCard } from "./teamMemberCard/teamMemberCard";

export default function TeamSection({ data }) {
  return (
    <div className="mt-[70px] text-mono-70">
      <h3 className="mb-[25px] font-bold text-[18px] text-black-rock lg:mb-3">
        {data.heading}
      </h3>
      <div className="mb-[70px] grid grid-cols-1 gap-x-10 gap-y-[30px] md:grid-cols-2">
        {data.teamMembers.length &&
          data.teamMembers.map((member, i) => {
            return <TeamMemberCard key={i} member={member} />;
          })}
      </div>
    </div>
  );
}
